// Local Dev
// export const REST_ENDPOINT = 'http://localhost:3000/';

// Prod
export const REST_ENDPOINT = 'https://booksapi.purplemdm.com/';
